import React, { Component } from 'react'
import API_URL from '../../../../common/url';
import $ from "../../../../common/AjaxRequest";
import dictCache from '../../../../common/dictCache';
import FomeList from './FomeList';
import moment from 'moment';
import { message } from 'antd';
import ExportUtil from '../../../../common/ExportUtil';


export default class ClientParams extends Component {
    state = {
        params: {},
        fileList: [],
        dataCollectionMediumList:[], //数据收集介质
        preFilterServeList:[], // 预筛服务
        geneticOfficeServeList:[], //遗传办服务  
    };

    componentDidMount() {
        const { params, fileList } = this.props;
        this.queryDataCollectionMediumList();
        this.queryPreFilterServeList();
        this.queryGeneticOfficeServeList();
        this.setState({
            params: { ...params },
            fileList: [...fileList],
        })
    }

    componentWillReceiveProps(nextProps) {
        const { params, fileList = [] } = nextProps;
        this.setState({
            params: { ...params },
            fileList: [...fileList],
        })
    }

    queryDataCollectionMediumList = () => {
        dictCache.getDict('CONFIG_WITH_CHILD_DATA_COLLECTION_MEDIUM', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.evaluate.queryConfigWithChildByType,
                data: { type: 'DATA_COLLECTION_MEDIUM' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({
                dataCollectionMediumList: res.list,
            });
        });
    }

    queryPreFilterServeList = () => {
        dictCache.getDict('CONFIG_WITH_CHILD_PRE_FILTER_SERVICE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.evaluate.queryConfigWithChildByType,
                data: { type: 'PRE_FILTER_SERVICE' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({
                preFilterServeList: res.list,
            });
        });
    }

    queryGeneticOfficeServeList = () => {
        dictCache.getDict('CONFIG_WITH_CHILD_GENETIC_OFFICE_SERVICE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.evaluate.queryConfigWithChildByType,
                data: { type: 'GENETIC_OFFICE_SERVICE' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({
                geneticOfficeServeList: res.list,
            });
        });
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        const { handleParamsChange } = this.props;
        params[key] = value;
        switch (key) {
            case 'preparePeriod': //准备期
                {
                    const { 
                        planFirstSiteStartDate,
                        planFirstInGroupDate,
                        preparePeriod = 0,
                        joinGroupPeriod = 0,
                        followUpPeriod = 0,
                        treatmentPeriod = 0,
                        survivalFollowUpPeriod = 0,
                        dbl = 0,
                        closeSite = 0,
                    } = params;
                    params.planLastSiteStartDate = planFirstSiteStartDate ? 
                        moment(planFirstSiteStartDate).add((value || 0) * 30, 'd').format('YYYY-MM-DD')
                        : '';
                    params.planLastInGroupDate = planFirstInGroupDate ? 
                        moment(planFirstInGroupDate).add(((value || 0) + (joinGroupPeriod || 0)) * 30, 'd').format('YYYY-MM-DD')
                        : '';
                    params.researchCycle = (Number(preparePeriod) + Number(joinGroupPeriod) + Number(treatmentPeriod) + Number(followUpPeriod) + Number(survivalFollowUpPeriod) + Number(dbl) + Number(closeSite)).toFixed(2);
                }
                break;
            case 'joinGroupPeriod' : //入组期
                {
                    const { planFirstInGroupDate, preparePeriod } = params;
                    params.planLastInGroupDate = planFirstInGroupDate ? 
                        moment(planFirstInGroupDate).add(((value || 0) + (preparePeriod || 0)) * 30, 'd').format('YYYY-MM-DD')
                        : '';
                }
            // case 'preparePeriod': //准备期
            case 'joinGroupPeriod': //入组
            case 'treatmentPeriod': //治疗
            case 'followUpPeriod': //随访
            case 'survivalFollowUpPeriod': //生存随访期
            case 'dbl': //DBL
            case 'closeSite': //关中心
            {
                const { 
                    preparePeriod = 0,
                    joinGroupPeriod = 0,
                    followUpPeriod = 0,
                    treatmentPeriod = 0,
                    survivalFollowUpPeriod = 0,
                    dbl = 0,
                    closeSite = 0,
                } = params;
                params.monitorCountSite = (Number(joinGroupPeriod) + ((Number(treatmentPeriod) + Number(followUpPeriod) + Number(dbl) + Number(closeSite)) / 2)).toFixed(0);
                params.researchCycle = (Number(preparePeriod) + Number(joinGroupPeriod) + Number(treatmentPeriod) + Number(followUpPeriod) + Number(survivalFollowUpPeriod) + Number(dbl) + Number(closeSite)).toFixed(2);
            }
            break;
            case 'randomCaseNum':
            case 'saeNum':
                {
                    // 预计SAE发生率（%） 自动计算
                    const { filterCaseNum, saeNum, randomCaseNum } = params;
                    params.estimateSaeHappenRate = ((saeNum || saeNum === 0) && randomCaseNum) ? 
                        Number((saeNum  * 100  / randomCaseNum).toFixed(2)) : 0;
                    params.planFilterFailRate = (filterCaseNum && randomCaseNum) ? 
                        Number(((filterCaseNum - randomCaseNum) * 100 / filterCaseNum).toFixed(2)) : 0;
                }
                break;
            case 'filterCaseNum': 
                {
                    const { filterCaseNum, randomCaseNum } = params;
                    params.planFilterFailRate = (filterCaseNum && randomCaseNum) ? 
                        Number(((filterCaseNum - randomCaseNum) * 100 / filterCaseNum).toFixed(2)) : 0;
                }
                break;
            case 'crcHourUnitPrice': //CRC小时单价（元/小时）
                params.crcUnitPrice = value ? Number((value * 160).toFixed(2)) : value;
                break;
            case 'pmHourUnitPrice': //PM小时单价（元/小时）
                params.pmUnitPrice = value ?  Number((value * 160).toFixed(2)) : value;
                break;
            case 'crcUnitPrice': //CRC单价（元/FTE）
                params.crcHourUnitPrice =  value ?  Number((value / 160).toFixed(2)) : value;
                break;
            case 'pmUnitPrice': //PM单价（元/FTE）
                params.pmHourUnitPrice =  value ?  Number((value / 160).toFixed(2)) : value;
                break;
            case 'needPreFilterService'://是否需要预筛服务
                params.preFilterServeIds = ''; //预筛服务
                break;
            case 'needGeneticManagerOfficeService': //是否需要遗传办服务
                params.geneticOfficeServeIds = ''; // 具体类别
                break;
            case 'needSitePathology': //是否需要中心病理
                if (value === '1') {
                    params.coordinatePathologicalSectionsCount = params.randomCaseNum;
                } else {
                    params.coordinatePathologicalSectionsCount = undefined; // 协调病理切片等试验标本处理次数
                }
                break;
            case 'concentratedPkCollectBloodNum': //是否需要密集PK采血
                params.perPatientIntensivePkBloodDraws = undefined; // 每例病人密集PK采血次数
                break;
        }
        this.setState({ params });
        handleParamsChange(params)
    };

    queryCanChange = value => {
        const { changeData } = this.props;
        const { changeFieldList = [] } = changeData || {};
        return changeFieldList.some(changeFieldValue => changeFieldValue == value)
    }

    updateClientParams = () => {
        const DomConfig = this.handleDomRender();
        DomConfig.map(el => {
            const { canChange = false, changeValue, name } = el;
            if (canChange) {
                this.handleChange(changeValue, name);
            }
        });
    }

    handleDomRender = () => {
        const { 
            params:{
                evaluateRecordId,
                needPreFilterService, //是否需要预筛服务
                needGeneticManagerOfficeService, //是否需要遗传办服务
                needSitePathology,
                concentratedPkCollectBloodNum,
            },
            fileList,
            dataCollectionMediumList, //数据收集介质
            preFilterServeList, // 预筛服务
            geneticOfficeServeList, //遗传办服务  ,pmName
        } = this.state;
        const { 
            isDocking = false, //是否是对接信息
            isCheck = false, //是否是查看或修改的弹窗
            record = {},
            changeData = {},
        } = this.props;  
        const { talAuth, deptBoAuth, bdBaAuth, seniorUserAuth } = record;
        const { curRole } = sessionStorage;
        const yseOrNo = [
            { label: '是', value: '1' },
            { label: '否', value: '0' },
        ];
        const dataCollectionMediumoption = dataCollectionMediumList.map(el => ({ label: el.configureValue, value: el.evaluateConfigureId }));
        const preFilterServeOption = preFilterServeList.map(el => ({ label: el.configureValue, value: el.evaluateConfigureId }));
        const geneticOfficeServeOption = geneticOfficeServeList.map(el => ({ label: el.configureValue, value: el.evaluateConfigureId }));
        const Config = [{
            label: `研究周期参数`,
            type: 'Title',
        }, {
            label: '研究周期（估计时间）',
            name: 'researchCycle',
            isRed: 'researchCycleRed',
            type: 'text',
            unit: '月',
        }, {
            label: '准备期',
            name: 'preparePeriod',
            isRed: 'preparePeriodRed',
            type: 'InputNumber',
            required: true,
            unit: '月',
            canChange: this.queryCanChange('preparePeriod'),
            changeValue: changeData['preparePeriod'],
            changeShow: changeData['preparePeriod'],
            typeProperty: {
                precision: 2,
            },
        }, {
            label: '入组期',
            name: 'joinGroupPeriod',
            isRed: 'joinGroupPeriodRed',
            type: 'InputNumber',
            required: true,
            unit: '月',
            canChange: this.queryCanChange('joinGroupPeriod'),
            changeValue: changeData['joinGroupPeriod'],
            changeShow: changeData['joinGroupPeriod'],
            typeProperty: {
                precision: 2,
            },
        }, {
            label: '治疗期',
            name: 'treatmentPeriod',
            isRed: 'treatmentPeriodRed',
            type: 'InputNumber',
            required: true,
            unit: '月',
            canChange: this.queryCanChange('treatmentPeriod'),
            changeValue: changeData['treatmentPeriod'],
            changeShow: changeData['treatmentPeriod'],
            typeProperty: {
                precision: 2,
            },
        }, {
            label: '随访期',
            name: 'followUpPeriod',
            isRed: 'followUpPeriodRed',
            type: 'InputNumber',
            required: true,
            unit: '月',
            canChange: this.queryCanChange('followUpPeriod'),
            changeValue: changeData['followUpPeriod'],
            changeShow: changeData['followUpPeriod'],
            typeProperty: {
                precision: 2,
            },
        }, {
            label: '生存随访期',
            name: 'survivalFollowUpPeriod',
            isRed: 'survivalFollowUpPeriodRed',
            type: 'InputNumber',
            required: true,
            unit: '月',
            canChange: this.queryCanChange('survivalFollowUpPeriod'),
            changeValue: changeData['survivalFollowUpPeriod'],
            changeShow: changeData['survivalFollowUpPeriod'],
            typeProperty: {
                precision: 2,
            },
        }, {
            label: 'DBL',
            name: 'dbl',
            isRed: 'dblRed',
            type: 'InputNumber',
            required: true,
            unit: '月',
            canChange: this.queryCanChange('dbl'),
            changeValue: changeData['dbl'],
            changeShow: changeData['dbl'],
            typeProperty: {
                precision: 2,
            },
        }, {
            label: '关中心',
            name: 'closeSite',
            isRed: 'closeSiteRed',
            type: 'InputNumber',
            required: true,
            unit: '月',
            canChange: this.queryCanChange('closeSite'),
            changeValue: changeData['closeSite'],
            changeShow: changeData['closeSite'],
            typeProperty: {
                precision: 2,
            },
        }, {
            label: '监查次数/中心',
            name: 'monitorCountSite',
            isRed: 'monitorCountSiteRed',
            type: 'text',
        }, {
            label: `启动&入组参数`,
            type: 'Title',
        }, {
            label: '筛选中心数（PSV）',
            name: 'filterSiteNum',
            isRed: 'filterSiteNumRed',
            type: 'InputNumber',
            canChange: this.queryCanChange('filterSiteNum'),
            changeValue: changeData['filterSiteNum'],
            changeShow: changeData['filterSiteNum'],
            required: true,
        }, {
            label: '启动中心数',
            name: 'startSiteNum',
            isRed: 'startSiteNumRed',
            type: 'InputNumber',
            canChange: this.queryCanChange('startSiteNum'),
            changeValue: changeData['startSiteNum'],
            changeShow: changeData['startSiteNum'],
            required: true,
        },  {
            label: 'DBL服务中心数',
            name: 'dblServiceSiteCount',
            isRed: 'dblServiceSiteCountRed',
            type: 'InputNumber',
            canChange: this.queryCanChange('dblServiceSiteCount'),
            changeValue: changeData['dblServiceSiteCount'],
            changeShow: changeData['dblServiceSiteCount'],
            required: true,
        }, {
            label: '关中心服务中心数',
            name: 'closeSiteServiceCount',
            isRed: 'closeSiteServiceCountRed',
            type: 'InputNumber',
            canChange: this.queryCanChange('closeSiteServiceCount'),
            changeValue: changeData['closeSiteServiceCount'],
            changeShow: changeData['closeSiteServiceCount'],
            required: true,
        }, {
            label: '非盲服务中心数',
            name: 'unblindedServiceSiteCount',
            isRed: 'unblindedServiceSiteCountRed',
            type: 'InputNumber',
            canChange: this.queryCanChange('unblindedServiceSiteCount'),
            changeValue: changeData['unblindedServiceSiteCount'],
            changeShow: changeData['unblindedServiceSiteCount'],
            required: true,
        }, {
            label: '筛选病例数',
            name: 'filterCaseNum',
            isRed: 'filterCaseNumRed',
            type: 'InputNumber',
            canChange: this.queryCanChange('filterCaseNum'),
            changeValue: changeData['filterCaseNum'],
            changeShow: changeData['filterCaseNum'],
            required: true,
        }, {
            label: '随机病例数',
            name: 'randomCaseNum',
            isRed: 'randomCaseNumRed',
            type: 'InputNumber',
            canChange: this.queryCanChange('randomCaseNum'),
            changeValue: changeData['randomCaseNum'],
            changeShow: changeData['randomCaseNum'],
            required: true,
        },{
            label: '计划筛选失败率',
            name: 'planFilterFailRate',
            isRed: 'planFilterFailRateRed',
            type: 'text',
            unit: '%',
        },{
            label: 'SAE数量',
            name: 'saeNum',
            isRed: 'saeNumRed',
            type: 'InputNumber',
            canChange: this.queryCanChange('saeNum'),
            changeValue: changeData['saeNum'],
            changeShow: changeData['saeNum'],
            required: true,
        },{
            label: '预计SAE发生率',
            name: 'estimateSaeHappenRate',
            isRed: 'estimateSaeHappenRateRed',
            type: 'text',
            unit: '%',
        }, {
            label: '每例病人影像刻盘上传(次数)',
            name: 'patientImagingData',
            isRed: 'patientImagingDataRed',
            type: 'InputNumber',
            canChange: this.queryCanChange('patientImagingData'),
            changeValue: changeData['patientImagingData'],
            changeShow: changeData['patientImagingData'],
            required: true,
        },  {
            label: '访视方案数',
            name: 'treatGroupCount',
            isRed: 'treatGroupCountRed',
            type: 'InputNumber',
            canChange: this.queryCanChange('treatGroupCount'),
            changeValue: changeData['treatGroupCount'],
            changeShow: changeData['treatGroupCount'],
            required: true,
            tipTitle: '对应“访视评估-临床PM参照临床方案预测项目参数-访视方案”所需设置的访视方案数量',
        },
        // {
        //     label: `预筛服务`,
        //     type: 'Title',
        // },{
        //     label: '是否需要预筛服务',
        //     name: 'needPreFilterService',
        //     isRed: 'needPreFilterServiceRed',
        //     type: 'Select',
        //     isYseOrNo: true,
        //     required: true,
        //     typeProperty: {
        //         option: yseOrNo,
        //     },
        // }, {
        //     label: '预筛服务',
        //     name: 'preFilterServeIds',
        //     showName: 'preFilterServeNames',
        //     isRed: 'preFilterServeNamesRed',
        //     type: 'SelectMultiple',
        //     disabled: needPreFilterService != 1,
        //     required: needPreFilterService == 1,
        //     typeProperty: {
        //         option: preFilterServeOption,
        //     },
        // }, 
        {
            label: `中心信息采集`,
            type: 'Title',
        }, {
            label: '组长单位',
            name: 'groupLeader',
            type: 'Input',
            canChange: this.queryCanChange('groupLeader'),
            changeValue: changeData['groupLeader'],
            changeShow: changeData['groupLeader'],
        }, {
            label: '组长单位备注说明',
            name: 'groupLeaderRemark',
            type: 'Input',
            canChange: this.queryCanChange('groupLeaderRemark'),
            changeValue: changeData['groupLeaderRemark'],
            changeShow: changeData['groupLeaderRemark'],
        }, {
            label: 'PI姓名',
            name: 'unitPiName',
            type: 'Input',
            canChange: this.queryCanChange('unitPiName'),
            changeValue: changeData['unitPiName'],
            changeShow: changeData['unitPiName'],
        }, {
            label: '单位PI姓名备注说明',
            name: 'unitPiNameRemark',
            type: 'Input',
            canChange: this.queryCanChange('unitPiNameRemark'),
            changeValue: changeData['unitPiNameRemark'],
            changeShow: changeData['unitPiNameRemark'],
        }, {
            label: '是否有中心实验室',
            name: 'haveCentralLab',
            isRed: 'haveCentralLabRed',
            type: 'Select',
            isYseOrNo: true,
            required: true,
            canChange: this.queryCanChange('haveCentralLab'),
            changeValue: changeData['haveCentralLab'],
            changeShow: changeData['haveCentralLab'] == '1' ? '是' : '否',
            typeProperty: {
                option: yseOrNo,
            },
        }, {
            label: '是否需要中心病理',
            name: 'needSitePathology',
            isRed: 'needSitePathologyRed',
            type: 'Select',
            isYseOrNo: true,
            required: true,
            canChange: this.queryCanChange('needSitePathology'),
            changeValue: changeData['needSitePathology'],
            changeShow: changeData['needSitePathology'] == '1' ? '是' : '否',
            typeProperty: {
                option: yseOrNo,
            },
        }, {
            label: '协调病理切片等试验标本处理次数',
            name: 'coordinatePathologicalSectionsCount',
            show: needSitePathology == 1,
            type: 'InputNumber',
            canChange: this.queryCanChange('coordinatePathologicalSectionsCount'),
            changeValue: changeData['coordinatePathologicalSectionsCount'],
            changeShow: changeData['coordinatePathologicalSectionsCount'] == '1' ? '是' : '否',
            required: needSitePathology == 1 ? true : false,
        }, {
            label: '是否需要中心阅片',
            name: 'needSiteReview',
            isRed: 'needSiteReviewRed',
            type: 'Select',
            isYseOrNo: true,
            required: true,
            canChange: this.queryCanChange('needSiteReview'),
            changeValue: changeData['needSiteReview'],
            changeShow: changeData['needSiteReview'] == '1' ? '是' : '否',
            typeProperty: {
                option: yseOrNo,
            },
        }, {
            label: '是否使用eTMF',
            name: 'useETmf',
            isRed: 'useETmfRed',
            type: 'Select',
            isYseOrNo: true,
            required: true,
            canChange: this.queryCanChange('useETmf'),
            changeValue: changeData['useETmf'],
            changeShow: changeData['useETmf'] == '1' ? '是' : '否',
            typeProperty: {
                option: yseOrNo,
            },
        }, {
            label: '是否需要CRC协助患者报销或赔偿流程',
            name: 'needCrcAssistReimburse',
            isRed: 'needCrcAssistReimburseRed',
            type: 'Select',
            isYseOrNo: true,
            required: true,
            canChange: this.queryCanChange('needCrcAssistReimburse'),
            changeValue: changeData['needCrcAssistReimburse'],
            changeShow: changeData['needCrcAssistReimburse'] == '1' ? '是' : '否',
            typeProperty: {
                option: yseOrNo,
            },
        }, {
            label: '是否涉及基因检测',
            name: 'involvingGeneticTesting',
            isRed: 'involvingGeneticTestingRed',
            type: 'Select',
            isYseOrNo: true,
            required: true,
            canChange: this.queryCanChange('involvingGeneticTesting'),
            changeValue: changeData['involvingGeneticTesting'],
            changeShow: changeData['involvingGeneticTesting'] == '1' ? '是' : '否',
            typeProperty: {
                option: yseOrNo,
            },
        }, {
            label: '是否需要协助收集OS证明文件',
            name: 'needCollectOsProof',
            isRed: 'needCollectOsProofRed',
            type: 'Select',
            isYseOrNo: true,
            required: true,
            canChange: this.queryCanChange('needCollectOsProof'),
            changeValue: changeData['needCollectOsProof'],
            changeShow: changeData['needCollectOsProof'] == '1' ? '是' : '否',
            typeProperty: {
                option: yseOrNo,
            },
        }, {
            label: '是否需要回溯性收集既往OS受试者死亡证明文件',
            name: 'needBacktrackCollectOsDeathProof',
            isRed: 'needBacktrackCollectOsDeathProofRed',
            type: 'Select',
            isYseOrNo: true,
            required: true,
            canChange: this.queryCanChange('needBacktrackCollectOsDeathProof'),
            changeValue: changeData['needBacktrackCollectOsDeathProof'],
            changeShow: changeData['needBacktrackCollectOsDeathProof'] == '1' ? '是' : '否',
            typeProperty: {
                option: yseOrNo,
            },
        }, {
            label: '是否需要密集PK采血',
            name: 'concentratedPkCollectBloodNum',
            isRed: 'concentratedPkCollectBloodNumRed',
            type: 'Select',
            isYseOrNo: isDocking ? false : true,
            required: true,
            canChange: this.queryCanChange('concentratedPkCollectBloodNum'),
            changeValue: changeData['concentratedPkCollectBloodNum'],
            changeShow: changeData['concentratedPkCollectBloodNum'] == '1' ? '是' : '否',
            typeProperty: {
                option: yseOrNo,
            },
        }, {
            label: '每例病人密集PK采血次数',
            name: 'perPatientIntensivePkBloodDraws',
            type: 'InputNumber',
            canChange: this.queryCanChange('perPatientIntensivePkBloodDraws'),
            changeValue: changeData['perPatientIntensivePkBloodDraws'],
            changeShow: changeData['perPatientIntensivePkBloodDraws'],
            show: concentratedPkCollectBloodNum == 1,
            required: concentratedPkCollectBloodNum == 1 ? true : false,
        }, {
            label: 'EDC系统语言',
            name: 'edcSystemLanguage',
            isRed: 'edcSystemLanguageRed',
            type: 'Input',
            canChange: this.queryCanChange('edcSystemLanguage'),
            changeValue: changeData['edcSystemLanguage'],
            changeShow: changeData['edcSystemLanguage'],
        }, {
            label: '数据收集介质',
            name: 'dataCollectionMediumId',
            showName: 'dataCollectionMediumName',
            isRed: 'dataCollectionMediumNameRed',
            type: 'Select',
            canChange: this.queryCanChange('dataCollectionMediumName'),
            changeValue: changeData['dataCollectionMediumId'],
            changeShow: changeData['dataCollectionMediumName'],
            typeProperty: {
                option: dataCollectionMediumoption,
            },
        },  
        // {
        //     label: `遗传办服务`,
        //     type: 'Title',
        // }, {
        //     label: '是否需要遗传办服务',
        //     name: 'needGeneticManagerOfficeService',
        //     isRed: 'needGeneticManagerOfficeServiceRed',
        //     type: 'Select',
        //     isYseOrNo: true,
        //     required: true,
        //     typeProperty: {
        //         option: yseOrNo,
        //     },
        // }, {
        //     label: '遗传办撰写业务类别',
        //     name: 'geneticOfficeServeIds',
        //     showName: 'geneticOfficeServeNames',
        //     isRed: 'geneticOfficeServeNamesRed',
        //     type: 'SelectMultiple',
        //     disabled: needGeneticManagerOfficeService != 1,
        //     required: needGeneticManagerOfficeService == 1,
        //     typeProperty: {
        //         option: geneticOfficeServeOption,
        //     },
        // },  {
        //     label: '遗传办牵头单位数量',
        //     name: 'geneticOfficeLeadCompanyCount',
        //     isRed: 'geneticOfficeLeadCompanyCountRed',
        //     type: 'InputNumber',
        // },{
        //     label: '遗传办申请批次',
        //     name: 'geneticOfficeRequestBatch',
        //     isRed: 'geneticOfficeRequestBatchRed',
        //     type: 'Input',
        // }, 
        {
            label: `伦理&数据清理`,
            type: 'Title',
        }, {
            label: '伦理更新递交次数/中心',
            name: 'ethicUpdateSubmitCountSite',
            isRed: 'ethicUpdateSubmitCountSiteRed',
            type: 'text',
        }, {
            label: '首次伦理递交次数/中心',
            name: 'firstEthicSubmitCountSite',
            isRed: 'firstEthicSubmitCountSiteRed',
            type: 'text',
        }, {
            label: '数据清理次数（阶段性）',
            name: 'dataCleanCountStage',
            isRed: 'dataCleanCountStageRed',
            type: 'text',
        }, {
            label: '数据清理次数（锁库）',
            name: 'dataCleanCountLock',
            isRed: 'dataCleanCountLockRed',
            type: 'text',
        }, {
            label: `中心入组计划`,
            type: 'Title',
        }, {
            label: '计划首家启动时间',
            name: 'planFirstSiteStartDate',
            isRed: 'planFirstSiteStartDateRed',
            type: 'text',
        }, {
            label: '计划最后一家中心启动时间',
            name: 'planLastSiteStartDate',
            isRed: 'planLastSiteStartDateRed',
            type: 'text',
        },  {
            label: '计划首例受试者入组时间',
            name: 'planFirstInGroupDate',
            isRed: 'planFirstInGroupDateRed',
            type: 'text',
        }, {
            label: '计划最后一例受试者入组时间',
            name: 'planLastInGroupDate',
            isRed: 'planLastInGroupDateRed',
            type: 'text',
        }, {
            label: `方案信息`,
            type: 'Title',
        }, {
            label: '备注及特殊要求',
            name: 'remarksSpecialRequirements',
            isRed: 'remarksSpecialRequirementsRed',
            type: 'RichText',
        }, {
            label: '上述参数的特殊情况说明',
            name: 'specialRemarkForParameters',
            isRed: 'specialRemarkForParametersRed',
            type: 'RichText',
        }, {
            label: '报价相关支持文件',
            name: 'fileList',
            type: 'Upload',
            canEdit: false,
            typeProperty: {
                action: API_URL.evaluate.uploadEnclosureFile,
                disabled: true,
                data: {
                    relateId: evaluateRecordId,
                    curUserId: sessionStorage.userId,
                    curEmployeeCode: sessionStorage.curEmployeeCode || '',
                    uploadType: 'EVALUATE_RECORD_CUSTOMER_FILE',
                },
                fileList: fileList,
                beforeUpload: this.beforeUpload,
                onChange: this.handleFileChange,
                onRemove: this.handleRemove,
                downLoadFile: this.downLoadFile,
            }
        }, {
            label: `CRC/PM单价信息`,
            type: 'Title',
            show: curRole === 'BA' || curRole === 'BAL' || bdBaAuth || talAuth || deptBoAuth || seniorUserAuth,
        }, {
            label: 'CRC小时单价',
            name: 'crcHourUnitPrice',
            isRed: 'crcHourUnitPriceRed',
            show: curRole === 'BA' || curRole === 'BAL' || bdBaAuth,
            type: 'InputNumber',
            unit: '元/小时',
            required: true,
            canChange: this.queryCanChange('crcHourUnitPrice'),
            changeValue: changeData['crcHourUnitPrice'],
            changeShow: changeData['crcHourUnitPrice'],
            typeProperty: {
                precision: 2,
            },
        }, {
            label: 'PM小时单价',
            name: 'pmHourUnitPrice',
            isRed: 'pmHourUnitPriceRed',
            show: curRole === 'BA' || curRole === 'BAL' || bdBaAuth,
            type: 'InputNumber',
            unit: '元/小时',
            required: true,
            canChange: this.queryCanChange('pmHourUnitPrice'),
            changeValue: changeData['pmHourUnitPrice'],
            changeShow: changeData['pmHourUnitPrice'],
            typeProperty: {
                precision: 2,
            },
        }, {
            label: 'CRC单价',
            name: 'crcUnitPrice',
            isRed: 'crcUnitPriceRed',
            show: curRole === 'BA' || curRole === 'BAL' || bdBaAuth,
            type: 'InputNumber',
            unit: '元/FTE',
            required: false,
            canChange: this.queryCanChange('crcUnitPrice'),
            changeValue: changeData['crcUnitPrice'],
            changeShow: changeData['crcUnitPrice'],
            typeProperty: {
                precision: 2,
            },
        }, {
            label: 'PM单价',
            name: 'pmUnitPrice',
            isRed: 'pmUnitPriceRed',
            show: curRole === 'BA' || curRole === 'BAL' || bdBaAuth,
            type: 'InputNumber',
            unit: '元/FTE',
            required: false,
            canChange: this.queryCanChange('pmUnitPrice'),
            changeValue: changeData['pmUnitPrice'],
            changeShow: changeData['crcUnitPrice'],
            typeProperty: {
                precision: 2,
            },
        }, {
            label: '津石评估CRC单价',
            name: 'crcEvaluateHourUnitPrice',
            isRed: 'crcEvaluateHourUnitPriceRed',
            show: talAuth || deptBoAuth || seniorUserAuth,
            type: 'text',
            unit: '元/小时',
        }, {
            label: '津石评估PM单价',
            name: 'pmEvaluateHourUnitPrice',
            isRed: 'pmEvaluateHourUnitPriceRed',
            show: talAuth || deptBoAuth || seniorUserAuth,
            type: 'text',
            unit: '元/小时',
        }, ];
        return Config
    }

    beforeUpload = file => {
        const { fileList = [] } = this.state;
        const isLt30M = file.size / 1024 / 1024 <=30;
        if (fileList.length >= 10) {
            message.warning('最多上传10个附件');
            return false;
        }
        if (!isLt30M) {
            message.warning('文件大小不能超过30M');
            return false;
        }
    }

    handleFileChange = ({ file, fileList }) => {
        if (file.status == "done") {
            if (file.response.error) {
                message.error(file.response.error);
                file.status = 'removed';
                const fileData = [...this.state.fileList];
                const index = fileData.indexOf(file);
                fileList.splice(index, 1);
            } else if (file.response.success) {
                message.success('上传附件成功');
            }
        }
        this.setState({ fileList });
    }

    handleRemove = file => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.deleteEnclosureFile,
            data: {
                fileMetaId: file.response.fileMetaId,
            },
            dataType: 'json',
            doneResult: res => {
                if (res.error) {
                    message.error(res.error);
                } else {
                    message.success(res.success);
                }
            }
        };
        $.sendRequest(options);
    }

    downLoadFile = (e, fileMetaId) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({ fileMetaId }, null, url);
    }

    render() {
        const { params } = this.state;
        const { type } = this.props;
        return (
            <FomeList 
                params={params}
                updateType={type}
                handleChange={this.handleChange}
                DomConfig={this.handleDomRender()}
            />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/ClientParams.js